<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { getFinancial } from "@/api/login.js"
export default {
  name: 'App',
  computed: {
    ...mapGetters(['customerListShow', 'chatShow'])
  },
  mounted () {
    this.getFinancial()
    this.setUserInfo()
    const mediaQuery = window.matchMedia('(max-width:800px)');
    mediaQuery.addListener(this.mach);
  },
  methods: {
    ...mapActions(["setUserInfo", 'setCustomerListShow', 'setChatShow', 'setAutoText']),
    mach(e) {
      let path = this.$route.path
      if (e.matches) {
        if (this.chatShow || this.customerListShow) {
          if (this.chatShow && path !== '/chat') {
            this.$router.push('/chat')
          } else if (this.customerListShow && path !== 'customerService') {
            this.$router.push('/customerService')
          }
          this.setCustomerListShow(false)
          this.setChatShow(false)
        }
      } else {
        if (path == '/chat' || path == '/customerService') {
          if (path == '/chat') {
            this.setChatShow(true)
          } else if (path == '/customerService') {
            this.setCustomerListShow(true)
          }
          this.$router.push('/')
        }
      }
    },
    getFinancial () {
      getFinancial().then((res) => {
        const obj = JSON.parse(res.data.configValue)
        this.setAutoText(obj.customerAutoText || '')
      })
    },
  },
}
</script>

<style>
*, html, body {
    margin: 0;
    padding: 0;
    font-family: SourceHanSerifCN;
}

img {
  user-select: none;
}

html {
  overflow-y: overlay;
  overflow-x: hidden;
}

@font-face {
  font-family: SourceHanSerifCN;  /* 自定义字体名称 */
  src: 
    url('~@/assets/font/SourceHanSerifCN-Bold.otf') format('opentype'),
    url('~@/assets/font/SourceHanSerifCN-ExtraLight.otf') format('opentype'),
    url('~@/assets/font/SourceHanSerifCN-Heavy.otf') format('opentype'),
    url('~@/assets/font/SourceHanSerifCN-Light.otf') format('opentype'),
    url('~@/assets/font/SourceHanSerifCN-Medium.otf') format('opentype'),
    url('~@/assets/font/SourceHanSerifCN-Regular.otf') format('opentype'),
    url('~@/assets/font/SourceHanSerifCN-SemiBold.otf') format('opentype');
}

:root {
  --pcRate: 1;
  --pcTextRate: 1;
}

::-webkit-scrollbar{
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track{
  background-color: rgba(0,0,0,0);
}

::-webkit-scrollbar-thumb{
  background-color: #ccc;
  border-radius: 10px;
}

@media only screen and (max-width:800px) {
  :root {
    --pcRate: 2;
    --pcTextRate: 3;
  }
}
</style>
